import { APIClient } from "./_api";

export function workerDeposit(data) {
  return APIClient.post(`coDeposit`, data);
}
export function adDeposit(data) {
  return APIClient.post(`adDeposit`, data);
}
export function finalPayment(data) {
  return APIClient.post(`finalPayment`, data);
}
export function addAdvertises(data) {
  return APIClient.post(`regAdv`, data);
}
export function getAdvDetail(data) {
  return APIClient.post(`viewAdv`, data);
}
export function checkPayment(data) {
  return APIClient.post(`payCheck`, data);
}
